export const SHORTLINK_CODE_LANDING_PAGE_DEU = 'deumag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_ENG = 'engmag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_FRA = 'framag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_ITA = 'itamag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_POL = 'polmag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_POR = 'pormag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_SPA = 'spamag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_SWE = 'swemag-index-org';
export const SHORTLINK_CODE_LANDING_PAGE_USA = 'usamag-index-org';

export const SHORTLINK_CODE_HEADER_CTA_DEU = 'deumag-all';
export const SHORTLINK_CODE_HEADER_CTA_ENG = 'engmag-all';
export const SHORTLINK_CODE_HEADER_CTA_FRA = 'framag-all';
export const SHORTLINK_CODE_HEADER_CTA_ITA = 'itamag-all';
export const SHORTLINK_CODE_HEADER_CTA_POL = 'polmag-all';
export const SHORTLINK_CODE_HEADER_CTA_POR = 'pormag-all';
export const SHORTLINK_CODE_HEADER_CTA_SPA = 'spamag-all';
export const SHORTLINK_CODE_HEADER_CTA_SWE = 'swemag-all';
export const SHORTLINK_CODE_HEADER_CTA_USA = 'usamag-all';
